export const productMedia = {
  "plastic-containers/hinged-containers-dual-tab-lock": [
    "/images/V/V61W.png",
    "/images/V/V96W.png",
    "/images/V/V93W.png",
    "/images/V/V91W.png",
    "/images/V/V61B.png",
    "/images/V/V96B.png",
    "/images/V/V83B.png",
    "/images/V/V61C.png",
    "/images/V/V96C.png",
  ],
  "plastic-containers/clear-hinged-containers-dual-tab-lock": [
    "/images/PSC/C57.png",
    "/images/PSC/C90.png",
  ],
  "plastic-containers/hinged-containers-center-slide": [
    "/images/CS/CS601.png",
    "/images/CS/CS903.png",
    "/images/CS/CS905.png",
  ],
  "plastic-containers/deli-containers": [
    "/images/Deli/S8.png",
    "/images/Deli/S12.png",
    "/images/Deli/S16.png",
    "/images/Deli/S24.png",
    "/images/Deli/S32.png",
  ],
  "plastic-containers/portion-cups-and-lids": [
    "/images/PC/P075.png",
    "/images/PC/P100.png",
    "/images/PC/P150.png",
    "/images/PC/P200.png",
    "/images/PC/P325.png",
    "/images/PC/P400.png",
    "/images/PC/P550.png",
  ],
  "plastic-containers/round-sealed-containers": [
    "/images/Round/R16.png",
    "/images/Round/R24.png",
    "/images/Round/R32.png",
    "/images/Round/R40.png",
    "/images/Round/R48.png",
  ],
  "plastic-containers/noodle-bowls": [
    "/images/Noodle/NB36.png",
    "/images/Noodle/NB42.png",
    "/images/Noodle/NB502.png",
  ],
  "plastic-containers/rectangular-sealed-containers": [
    "/images/E/E12.png",
    "/images/E/E16.png",
    "/images/E/E24.png",
    "/images/E/E28.png",
    "/images/E/E32.png",
  ],
  "plastic-containers/heavy-duty-deep-rectangular-containers": [
    "/images/TY/TY32.png",
  ],
  "plastic-containers/compartmental-sealed-containers": [
    "/images/Compartment/TY232.png",
    "/images/Compartment/TY333.png",
    "/images/Compartment/TY339.png",
  ],
  "cups/pet-cold-cups": [
    "/images/CC/12.png",
    "/images/CC/16.png",
    "/images/CC/24.png",
    "/images/CC/lids.png",
  ],
  "cups/paper-hot-cups": [
    "/images/HC/cups.png",
    "/images/HC/lidcup.png",
    "/images/HC/lid1.png",
    "/images/HC/lid2.png",
    "/images/HC/sleeve.png",
  ],
  "cups/cup-accessories": [
    "/images/Misc/Holder.png",
    "/images/Misc/straws.png",
    "/images/Misc/wrapStraws.png",
  ],
  "aluminum/round-aluminum-pans": [
    "/images/Aluminum/Round.png",
    "/images/Aluminum/DomeRound.png",
  ],
  "aluminum/oblong-aluminum-pans": [
    "/images/Aluminum/Oblong.png",
    "/images/Aluminum/ObBottom.png",
    "/images/Aluminum/ObLid.png",
  ],
  "aluminum/full-size-aluminum-pans": [
    "/images/Aluminum/Full.png",
    "/images/Aluminum/FullM.png",
    "/images/Aluminum/FullS.png",
  ],
  "aluminum/half-size-aluminum-pans": [
    "/images/Aluminum/Half.png",
    "/images/Aluminum/HalfM.png",
  ],
  "sugarcane/sugarcane-plates-and-bowls": [
    "/images/SC/9SCP.png",
    "/images/SC/Oval.png",
    "/images/SC/12oz.png",
  ],
  "sugarcane/sugarcane-hinged-containers": [
    "/images/SC/SC96.png",
    "/images/SC/SC61.png",
    "/images/SC/SC91.png",
  ],
  "misc/medium-duty-cutlery": ["/images/Cutlery/kit.png"],
  "misc/chopsticks": ["/images/Cutlery/chopsticks.png"],
  "misc/receipt-paper": ["/images/Misc/thermal.png"],
  "misc/nitrile-gloves": ["/images/Misc/gloves.png"],
  "misc/vinyl-gloves": ["/images/Misc/vinyl.png"],
  "misc/food-film": ["/images/Misc/film.png"],
  "misc/aluminum-foil": ["/images/Misc/roll.png", "/images/Misc/sheet.png"],
  "misc/napkins": [
    "/images/Napkin/bev.png",
    "/images/Napkin/lunch.png",
    "/images/Napkin/dinner.png",
    "/images/Napkin/tallfold.png",
    "/images/Napkin/dispenser.png",
  ],
  "misc/heavy-duty-cutlery": [
    "/images/Cutlery/fork.png",
    "/images/Cutlery/tspoon.png",
    "/images/Cutlery/sspoon.png",
    "/images/Cutlery/knife.png",
  ],
  "bags/brown-paper-bags": [
    "/images/Bag/duro.png",
    "/images/Bag/duro2.png",
    "/images/Bag/big.png",
  ],
  "bags/paper-handle-bags": [
    "/images/Bag/twisted.png",
    "/images/Bag/twisted2.png",
  ],
  "bags/non-woven-reusable-bags": ["/images/Bag/NWB.png"],
  "bags/plastic-t-shirt-bags": ["/images/Bag/tshirt.png"],
  "bags/trash-bags": ["/images/Bag/trash.png"],
};

export const imagesForProduct = (product) =>
  productMedia[`${product.category}/${product.slug}`] || [];
